import { GetterTree } from "vuex";
import { RootState, RootGetters } from "@/store/interfaces/root";
import { GetterTypes } from "./getter-types";

export const getters: GetterTree<RootState, RootState> & RootGetters = {
  [GetterTypes.GET_LOADING_STATUS](state) {
    return state.loading;
  },
  [GetterTypes.GET_CSRF_INFORMATION](state) {
    return state.csrf;
  },
  [GetterTypes.GET_BANNER_STATUS](state) {
    return state.banner;
  },
  [GetterTypes.GET_DIALOG_STATUS](state) {
    return state.dialog;
  },
  [GetterTypes.GET_NOTIFICATION_STATUS](state) {
    return state.notification;
  },
  [GetterTypes.GET_ALERT_STATUS](state) {
    return state.alert;
  }
};
